export default class MaskedInput {
  static handleChange (event, setFieldValue) {
    const { name, rawValue } = event.target
    setFieldValue (name, rawValue)
  }
}
